module.exports = __webpack_public_path__ + "img/add.60039cb0.svg";